var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',{model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},[_c('vs-tab',{attrs:{"label":"Picking"}},[_c('process',{on:{"edit":_vm.edit}})],1),_c('vs-tab',{attrs:{"label":"Edit"}},[(!_vm.allowEdit)?_c('div'):_c('edit',{attrs:{"picking_id":_vm.pickingId},on:{"close":_vm.close}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }